import React, { useEffect, useState } from "react";
import { Drawer, InputLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  Typography,
  Avatar,
  IconButton,
  Button,
  TextField,
  MenuItem,
  Divider,
  InputAdornment,
} from "@mui/material";
import { IoMdClose } from "react-icons/io";
import CustomInput from "../Common/CustomInput";
import CustomSelect from "../Common/CustomSelect";
import { useMutation, useQuery } from "@apollo/client";
import { GET_ROLES } from "../../Utils/Queries";
import { CREATE_TEAM } from "../../Utils/Mutation";
import { useSnackbarHook } from "../../hooks/useSnackbarHook";
import Loader from "../Common/Loader";
import { PiEyeSlashThin, PiEyeThin } from "react-icons/pi";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 540,
    flexShrink: 0,
    p: 4,
  },
  drawerPaper: {
    width: 540,
    p: 4,
  },
  toolbar: theme.mixins.toolbar,
}));
const CreateTeam = ({ open, onClose, refetchTeam }) => {
  const classes = useStyles();
  const { handleClick } = useSnackbarHook();

  const { data, loading, refetch } = useQuery(GET_ROLES);

  useEffect(() => {
    refetch();
  }, [open]);

  const [firstName, setFirstName] = useState("");
  const [access, setAccess] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = React.useState(false);

  const [createTeam, { loading: teamLoading }] = useMutation(CREATE_TEAM);

  const handleCreateTeam = async () => {
    await createTeam({
      variables: {
        firstName,
        lastName,
        role,
        email,
        phone,
        password,
        accessType: access,
      },
    })
      .then((res) => {
        handleClick("User Created Successfully", "success");
        setFirstName("");
        setLastName("");
        setPhone("");
        setEmail("");
        setPassword("");
        onClose();
        refetchTeam();
      })
      .catch((err) => {
        handleClick(`${err.message}`, "error");
      });
  };

  return (
    <Drawer
      className={classes.drawer}
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      {(teamLoading || loading) && <Loader />}
      <Box sx={{ px: 4, py: 5 }} className={classes.toolbar}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Lato",
              color: "#0D0D0D",
              fontSize: "20px",
              fontWeight: 700,
            }}
          >
            Add User
          </Typography>
          <IconButton onClick={onClose}>
            <IoMdClose style={{ fontSize: "20px", color: "#000" }} />
          </IconButton>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography
            sx={{ color: "#4D4D4D", fontSize: "14px", fontWeight: 500 }}
          >
            Select Role <span style={{ color: "#FF4C5E" }}>*</span>
          </Typography>
          <Box sx={{ mt: 1 }}>
            <TextField
              select
              fullWidth
              value={role}
              onChange={(e) => setRole(e.target.value)}
              size="large"
              InputProps={{
                style: {
                  marginBottom: "20px",
                  fontSize: "13px",
                  borderRadius: "8px",
                  offset: " 1px solid #f2f2f2",
                  fontWeight: 400,
                  height: "45px",
                  // Replace with your desired font family
                },
              }}
            >
              {data?.getAdminRoles?.map((option, index) => (
                <MenuItem
                  sx={{ color: "#4A414F", fontWeight: 400, fontSize: "13px" }}
                  key={index}
                  value={option._id}
                >
                  {option.title}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Typography
            sx={{ color: "#4D4D4D", fontSize: "14px", fontWeight: 500 }}
          >
            Access Type <span style={{ color: "#FF4C5E" }}>*</span>
          </Typography>
          <Box sx={{ mt: 1 }}>
            <TextField
              select
              fullWidth
              value={access}
              onChange={(e) => setAccess(e.target.value)}
              size="large"
              SelectProps={{
                displayEmpty: true,
              }}
              InputProps={{
                style: {
                  marginBottom: "20px",
                  fontSize: "13px",
                  borderRadius: "8px",
                  offset: " 1px solid #f2f2f2",
                  fontWeight: 400,
                  height: "45px",
                  // Replace with your desired font family
                },
              }}
            >
              <MenuItem
                sx={{ color: "#4A414F", fontWeight: 400, fontSize: "13px" }}
                key={""}
                value={""}
                disabled
              >
                Select
              </MenuItem>
              <MenuItem
                sx={{ color: "#4A414F", fontWeight: 400, fontSize: "13px" }}
                key={"View Access"}
                value={"View Access"}
              >
                View Access
              </MenuItem>
              <MenuItem
                sx={{ color: "#4A414F", fontWeight: 400, fontSize: "13px" }}
                key={"View and Edit Access"}
                value={"View and Edit Access"}
              >
                View & Edit Access
              </MenuItem>
            </TextField>
          </Box>

          <Box sx={{ mt: 0 }}>
            <CustomInput
              label="First Name"
              required
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </Box>
          <Box sx={{ mt: 2 }}>
            <CustomInput
              label="Last Name"
              required
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </Box>

          <Box sx={{ mt: 2 }}>
            <CustomInput
              label="Email Address"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Box>

          <Box sx={{ mt: 2 }}>
            <TextField
              label="Create Password"
              type={showPassword ? "text": "password"}
              fullWidth
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="dense"
              InputProps={{
                style: {
                  fontSize: "13px",
                  borderRadius: "8px",
                  height: "55px",
                },
                endAdornment: (
                  <InputAdornment
                    onClick={() => setShowPassword(!showPassword)}
                    position="end"
                  >
                    {!showPassword ? <PiEyeSlashThin style={{fontSize:'18px'}} /> : <PiEyeThin style={{fontSize:'18px'}}/>}
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Button
            onClick={handleCreateTeam}
            variant="contained"
            fullWidth
            sx={{ my: 4, borderRadius: "50px", height: "50px" }}
            disabled={!firstName || !lastName || !email || !role || !password}
          >
            Create Team
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};
export default CreateTeam;
